<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <Form ref="form" :model="cert" :rules="certForm" label-position="left" :label-width="90" @submit.native.prevent>
      <div class="product form_style">
        <Row :gutter="16">
          <!-- <Col span="6" class="consignee_name">
            <FormItem prop="consigneeName" label="收货人：">
              <AutoComplete v-model.trim="cert.consigneeName" @on-search="handleCNSearch" :transfer="true" @on-focus="handleCNFocus" icon="ios-more" clearable placeholder="请填写收货人" ref="autoCompleteCN">
                <Option v-for="item in books" :value="item.consigneeName" :key="item.id" class="coo_autocomplete_option">
                  <div @click.prevent="handleCNSelect(item.id)">{{item.consigneeName}}</div>
                </Option>
              </AutoComplete>
            </FormItem>
          </Col> -->
          <Col span="6" class="consignee_name">
            <FormItem prop="consigneeName" label="收货人：">
              <XAutoComplete v-model.trim="cert.consigneeName" @on-search="handleCNSearch" :transfer="true" @on-focus="handleCNFocus" icon="ios-more" clearable placeholder="请填写收货人" ref="autoCompleteCN">
                <Option v-for="item in books" :value="item.consigneeName" :key="item.id" class="coo_autocomplete_option">
                  <div @click.prevent="handleCNSelect(item.id)">{{item.consigneeName}}</div>
                </Option>
              </XAutoComplete>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="6">
            <FormItem prop="importer" label="目的地：">
              <Input v-model.trim="cert.importer" clearable placeholder="请填写目的地"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem prop="consigneeAddress" label="收货人地址：" :label-width="100">
              <Input v-model.trim="cert.consigneeAddress" clearable placeholder="请填写收货人地址"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="6">
            <FormItem prop="exporter" label="起运地：">
              <Input v-model.trim="cert.exporter" clearable placeholder="请填写起运地"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem prop="exporterName" label="出口人名称：" :label-width="100">
              <Input v-model.trim="cert.exporterName" clearable placeholder="请填写出口人名称"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem prop="exporterAddress" label="出口人地址：" :label-width="100">
              <Input v-model.trim="cert.exporterAddress" clearable placeholder="请填写出口人地址"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- <Col span="6" class="invoice_code">
            <FormItem prop="invoiceCode" label="发票号：">
              <AutoComplete v-model.trim="cert.invoiceCode" @on-search="handleICSearch" :transfer="true" @on-focus="handleICFocus" icon="ios-more" clearable placeholder="请填写发票号" ref="autoCompleteIC">
                <Option v-for="item in invoiceList" :value="item.invoiceCode" :key="item.invoiceCode" class="coo_autocomplete_option">
                  <div @click.prevent="handleICSelect(item.invoiceCode)">{{item.invoiceCode}} - {{item.importer}}</div>
                </Option>
              </AutoComplete>
            </FormItem>
          </Col> -->
          <Col span="6" class="invoice_code">
            <FormItem prop="invoiceCode" label="发票号：">
              <XAutoComplete v-model.trim="cert.invoiceCode" @on-search="handleICSearch" :transfer="true" @on-focus="handleICFocus" icon="ios-more" clearable placeholder="请填写发票号" ref="autoCompleteIC">
                <Option v-for="item in invoiceList" :value="item.invoiceCode" :key="item.invoiceCode" class="coo_autocomplete_option">
                  <div @click.prevent="handleICSelect(item.invoiceCode)">{{item.invoiceCode}} - {{item.importer}}</div>
                </Option>
              </XAutoComplete>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem prop="invoiceTime" label="发票日期：" :label-width="100">
              <DatePicker type="date" v-model.trim="cert.invoiceTime" placeholder="请选择发票日期" clearable :editable="false" style="width:100%;"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </div>
      <div class="projects form_style" v-if="cert.projects && cert.projects.length">
        <div class="project" v-for="(item, index) in cert.projects" :key="`project-${index}`">
          <Row :gutter="16">
            <Col span="6">
              <FormItem :prop="`projects.${index}.goodsCount`" label="成品数量：" :label-width="90" :rules="{required: true, type: 'integer', min: 1, message: 'Item ' + index +' can not be empty', trigger: 'blur', transform: value => Number(value)}">
                <Input v-model.trim="item.goodsCount" placeholder="请填写成品数量" readonly disabled></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :prop="`projects.${index}.goodsCode`" label="成品商品编码：" :label-width="100" :rules="{required: true, message: 'Item ' + index +' can not be empty', trigger: 'blur'}">
                <Input v-model.trim="item.goodsCode" placeholder="请填写成品商品编码" readonly disabled></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :prop="`projects.${index}.goodsPrice`" label="成品价格：" :label-width="100" :rules="[{type: 'number', required: true, message: 'Item ' + index +' can not be empty', trigger: 'blur'}, { validator: validatePrice, trigger: 'blur' }]">
                <Input v-model.trim="item.goodsPrice" placeholder="请填写成品价格" readonly disabled></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="6">
              <FormItem :prop="`projects.${index}.packageCount`" label="包装件数：" :label-width="90" :rules="{required: true, message: 'Item ' + index +' can not be empty', trigger: 'blur'}">
                <Input v-model.trim="item.packageCount" placeholder="请填写包装件数" clearable></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :prop="`projects.${index}.type`" label="种类：" :label-width="100" :rules="{required: true, message: 'Item ' + index +' can not be empty', trigger: 'blur'}">
                <Input v-model.trim="item.type" placeholder="请填写种类" clearable></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="6">
              <FormItem :prop="`projects.${index}.grossWeight`" label="毛重：" :label-width="90" :rules="{required: true, message: 'Item ' + index +' can not be empty', trigger: 'blur'}">
                <Input v-model.trim="item.grossWeight" placeholder="请填写毛重" clearable></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :prop="`projects.${index}.otherNum`" label="其他数量：" :label-width="100" :rules="{required: true, message: 'Item ' + index +' can not be empty', trigger: 'blur'}">
                <Input v-model.trim="item.otherNum" placeholder="请填写其他数量" clearable></Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
    </Form>
    <Button type="primary" class="btn" :loading="isSaving" @click.prevent="ok"><span>确认</span></Button>
    <Loader :loadType="1" v-show="isShowModalLoader" class="black" style="top:-20px;"></Loader>
  </div>
</template>

<script>
import _ from 'lodash'
import Loader from '@/components/layout/Loader'

export default {
  name: 'RulesDecideCertAdd',
  components: { Loader },
  props: {
    mh: {
      type: Number
    }
  },
  data () {
    return {
      isShowModalLoader: false,
      isSaving: false,
      books: [],
      invoiceList: [],
      certId: null,
      cert: {
        importer: '',
        consigneeName: '',
        consigneeAddress: '',
        exporter: '',
        exporterName: '',
        exporterAddress: '',
        invoiceCode: '',
        invoiceTime: '',
        // https://cn.vuejs.org/v2/guide/list.html#%E6%B3%A8%E6%84%8F%E4%BA%8B%E9%A1%B9
        // vm.$set or vm.items.splice
        projects: []
      },
      validatePrice: (rule, value, callback) => {
        value = parseFloat(this._.trim(`${value}`))
        if (!value || this._.isNaN(value) || value <= 0 || !this.$options.filters.isPrice(`${value}`)) {
          callback(new Error('请填写正确的单价'))
        } else {
          callback()
        }
      },
      certForm: {
        consigneeName: [{ required: true, message: '请填写收货人', trigger: 'change' }],
        importer: [{ required: true, message: '请填写目的地', trigger: 'blur' }],
        consigneeAddress: [{ required: true, message: '请填写收货人地址', trigger: 'blur' }],
        exporter: [{ required: true, message: '请填写起运地', trigger: 'blur' }],
        exporterName: [{ required: true, message: '请填写出口人名称', trigger: 'blur' }],
        exporterAddress: [{ required: true, message: '请填写出口人地址', trigger: 'blur' }],
        invoiceCode: [{ required: true, message: '请填写发票号', trigger: 'change' }],
        invoiceTime: [{ type: 'date', required: true, message: '请填写选择发票日期', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleCNSearch: _.debounce(function (value) {
      value = this._.trim(value || '')
      // if (value) {
      //   this.cert.consigneeName = value
      //   this.$refs.autoCompleteCN && this.$refs.autoCompleteCN.$refs.input && this.$refs.autoCompleteCN.$refs.input.focus()
      // }
      this.$api.coo.cert.bookList(this._.assign({page: 1, size: 15}, value ? {consigner: value} : {}), {
        success: response => {
          if (response.data.code === 200) {
            this.books = response.data.data || []
          }
        }
      })
    }, 350),
    handleCNSelect (id) {
      id = this._.trim(id || '')
      if (id) {
        let item = this._.find(this.books, o => parseInt(o.id) === parseInt(id))
        if (item) {
          this.certId = parseInt(id)
          this.cert.importer = item.importer
          this.cert.exporter = item.exporter
          this.cert.exporterName = item.exporterName
          this.cert.exporterAddress = item.exporterAddress
          this.cert.consigneeAddress = item.consigneeAddress
        }
      }
    },
    handleCNFocus: _.debounce(function () {
      if (!this.books || this.books.length === 0) {
        let value = this._.trim(this.cert.consigneeName || '')
        this.$api.coo.cert.bookList(this._.assign({page: 1, size: 15}, value ? {consigner: value} : {}), {
          success: response => {
            if (response.data.code === 200) {
              this.books = response.data.data || []
            }
          }
        })
      }
    }, 350),
    handleICSearch: _.debounce(function (value) {
      this.cert.projects = []
      value = this._.trim(value || '')
      // if (value) {
      //   this.cert.invoiceCode = value
      //   this.$refs.autoCompleteIC && this.$refs.autoCompleteIC.$refs.input && this.$refs.autoCompleteIC.$refs.input.focus()
      // }
      this.$api.coo.cert.invoiceList(this._.assign({page: 1, size: 15}, value ? {invoice: value} : {}), {
        success: response => {
          if (response.data.code === 200) {
            this.invoiceList = response.data.data || []
          }
        }
      })
    }, 350),
    handleICSelect (invoiceCode) {
      if (!this.isShowModalLoader) {
        invoiceCode = this._.trim(invoiceCode || '')
        if (invoiceCode) {
          this.isShowModalLoader = true
          this.$api.coo.cert.confirm({invoice: invoiceCode}, {
            success: response => {
              if (response.data.code === 200) {
                if (response.data.data) {
                  this.cert.projects = this._.map(response.data.data.projects || [], o => this._.assign({}, o, {packageCount: '', type: '', grossWeight: '', otherNum: ''}))
                }
              } else {
                this.$Message.warning({content: this.$t('common.codeError'), closable: true})
              }
              this.isShowModalLoader = false
            },
            error: errorMsg => {
              this.isShowModalLoader = false
              this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
              this.$Loading.error()
            }
          })
        }
      }
    },
    handleICFocus: _.debounce(function () {
      if (!this.invoiceList || this.invoiceList.length === 0) {
        let value = this._.trim(this.cert.invoiceCode || '')
        this.$api.coo.cert.invoiceList(this._.assign({page: 1, size: 15}, value ? {invoice: value} : {}), {
          success: response => {
            if (response.data.code === 200) {
              this.invoiceList = response.data.data || []
            }
          }
        })
      }
    }, 350),
    ok () {
      if (!this.isSaving) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.cert.projects && this.cert.projects.length > 0) {
              this.isSaving = true
              this.isShowModalLoader = true
              this.$Loading.start()
              let _data = {
                importer: this.cert.importer,
                consigneeName: this.cert.consigneeName,
                consigneeAddress: this.cert.consigneeAddress,
                exporter: this.cert.exporter,
                exporterName: this.cert.exporterName,
                invoiceCode: this.cert.invoiceCode,
                exporterAddress: this.cert.exporterAddress,
                invoiceTime: this.$options.filters.dataFormat(this.cert.invoiceTime.getTime(), 'dateTime.short5'),
                projects: this.cert.projects
              }
              if (this.certId) {
                let bookItem = this._.find(this.books, o => parseInt(o.id) === parseInt(this.certId))
                if (bookItem && bookItem.consigneeName === this.cert.consigneeName) {
                  _data['id'] = parseInt(this.certId)
                }
              }
              this.$api.coo.cert.create(_data, {
                success: response => {
                  this.$Loading.finish()
                  this.$Message.destroy()
                  if (response.data.code === 200) {
                    this.$Message.success({
                      content: '证书生成成功',
                      closable: true,
                      onClose: () => {
                        this.isSaving = false
                        this.$router.push({name: 'RulesDecideCertList'})
                      }
                    })
                  } else {
                    this.$Message.warning({content: '证书生成失败，请重试！', closable: true})
                    this.isSaving = false
                  }
                  this.isShowModalLoader = false
                },
                error: (errorMsg) => {
                  this.isSaving = false
                  this.isShowModalLoader = false
                  this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
                  this.$Loading.error()
                }
              })
            } else {
              this.$Message.destroy()
              this.$Message.info({content: '所属发票项目不存在', closable: true})
            }
          }
        })
      }
    }
  }
}
</script>
<style>
  .coo_autocomplete_option.ivu-select-item{
    padding: 0;
  }
  .coo_autocomplete_option.ivu-select-item div{
    padding: 7px 16px;
  }
</style>
<style scoped>
  .invoice_container{
    background-color: #fff;
    padding: 28px 24px 42px;
  }
  .form_style{
    font-size: 13px;
  }
  .form_style >>> .ivu-form-item{
    margin-bottom: 0;
    width: 90%;
  }
  .form_style >>> .ivu-form-item-error-tip{
    right: 0;
    left: inherit;
    top: 10px;
    padding-top: 0;
  }
  .form_style >>> .ivu-row{
    margin-bottom: 24px;
  }
  .form_style >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .form_style >>> .ivu-row .ivu-col{
    display: flex;
    align-items: center;
    height: 32px;
  }
  .form_style >>> .ivu-row .ivu-col .title{
    white-space: nowrap;
  }
  .form_style >>> .ivu-row .ivu-col .ivu-input{
    border-color: #DBDBDB;
    border-radius: 2px;
  }
  .form_style >>> .ivu-row .ivu-col .ivu-form-item-error .ivu-input{
    border-color: #ed3f14;
  }
  .form_style >>> .ivu-row .ivu-col .ivu-input:focus{
    border-color: #57a3f3;
  }
  .product .consignee_name >>> .ivu-form-item-label,
  .product .invoice_code >>> .ivu-form-item-label{
    color: #1F8AFD;
  }
  .form_style >>> .ivu-input-wrapper .ivu-input-icon{
    line-height: 32px !important;
    width: 32px;
    height: 32px;
  }
  .form_style >>> .ivu-form-item-required .ivu-form-item-label:before{
    content: ''
  }
  .form_style >>> .ivu-form-item-error-tip{
    display: none;
  }
  .projects{
    /* background-color: #F8F8F8;
    border-radius: 5px; */
    /* padding: 20px 12px; */
    /* padding: 20px 0;
    margin-top: 20px; */
    margin-top: 20px;
  }
  .projects.form_style .ivu-row{
    margin-bottom: 20px;
  }
  .projects .project{
    background-color: #F8F8F8;
    border-radius: 5px;
    padding: 20px 0;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .product >>> .ivu-row .ivu-col:first-child .ivu-form-item .ivu-form-item-label{
    padding-left: 10px;
  }
  .projects >>> .ivu-row .ivu-col:first-child .ivu-form-item .ivu-form-item-label{
    padding-left: 12px;
  }
  /* .projects >>> .ivu-form-item .ivu-form-item-label{
    text-align: right;
  } */
  .btn{
    width: 100px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 32px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    background-color: #1F8AFD;
    color: #fff;
    margin: 30px auto 0;
    display: block;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/CertAdd.vue